import React, {
    useState,
} from "react";

import {
    FiAlertCircle,
    FiCheckCircle,
    FiDownload,
    FiFileText,
    FiRefreshCw,
} from "react-icons/fi";

import {
    downloadGstReport,
} from "../utils/gstExport";


const GstFilingPanel = ({
    fromDate,
    toDate,
    financialYear,
}) => {
    const [
        gstin,
        setGstin,
    ] = useState("");


    const [
        returnPeriod,
        setReturnPeriod,
    ] = useState("");


    const [
        exporting,
        setExporting,
    ] = useState("");


const handleExport =
    async (
        reportType,
        format
    ) => {
        try {
            setExporting(
                `${reportType}-${format}`
            );


            const response =
                await downloadGstReport({
                    reportType,

                    format,

                    fromDate,

                    toDate,

                    financialYear,

                    gstin,

                    returnPeriod,
                });


            if (
                !response?.success
            ) {
                window.alert(
                    response?.message ||
                    "Unable to export GST report."
                );

                return;
            }

        } catch (error) {
            console.error(
                "GST export error:",
                error
            );


            window.alert(
                error?.message ||
                "Unable to export GST report."
            );

        } finally {
            setExporting(
                ""
            );
        }
    };

    return (
        <div className="gst-filing-panel">

            <section className="gst-filing-header">

                <div>

                    <FiFileText />

                    <div>

                        <strong>
                            GST Filing & Export
                        </strong>

                        <span>
                            Validate and download final GST working files
                        </span>

                    </div>

                </div>

            </section>


            <section className="gst-filing-fields">

                <div>

                    <label>
                        GSTIN
                    </label>

                    <input
                        type="text"
                        value={
                            gstin
                        }
                        placeholder="22AAAAA0000A1Z5"
                        onChange={(
                            event
                        ) =>
                            setGstin(
                                event
                                    .target
                                    .value
                                    .toUpperCase()
                            )
                        }
                    />

                </div>


                <div>

                    <label>
                        Return Period
                    </label>

                    <input
                        type="text"
                        value={
                            returnPeriod
                        }
                        placeholder="082026"
                        onChange={(
                            event
                        ) =>
                            setReturnPeriod(
                                event
                                    .target
                                    .value
                            )
                        }
                    />

                </div>


                <div>

                    <label>
                        Financial Year
                    </label>

                    <input
                        type="text"
                        value={
                            financialYear
                        }
                        readOnly
                    />

                </div>

            </section>


            <section className="gst-filing-info">

                <FiAlertCircle />

                <div>

                    <strong>
                        Validate before filing
                    </strong>

                    <span>
                        Resolve reconciliation, GSTIN, HSN and tax classification
                        errors before final export.
                    </span>

                </div>

            </section>


            <section className="gst-filing-export-grid">

                <div>

                    <FiCheckCircle />

                    <strong>
                        GSTR-1
                    </strong>

                    <span>
                        Outward supplies
                    </span>


                    <button
                        type="button"
                        className="gst-dashboard-button"
                        onClick={() =>
                            handleExport(
                                "GSTR1",
                                "json"
                            )
                        }
                    >
                        {exporting ===
                        "GSTR1-json" ? (
                            <FiRefreshCw className="gst-dashboard-spinner" />
                        ) : (
                            <FiDownload />
                        )}

                        JSON
                    </button>


                    <button
                        type="button"
                        className="gst-dashboard-button"
                        onClick={() =>
                            handleExport(
                                "GSTR1",
                                "csv"
                            )
                        }
                    >
                        <FiDownload />

                        CSV
                    </button>

                </div>


                <div>

                    <FiCheckCircle />

                    <strong>
                        GSTR-3B
                    </strong>

                    <span>
                        Tax and ITC working
                    </span>


                    <button
                        type="button"
                        className="gst-dashboard-button"
                        onClick={() =>
                            handleExport(
                                "GSTR3B",
                                "json"
                            )
                        }
                    >
                        <FiDownload />

                        JSON
                    </button>

                </div>


                <div>

                    <FiCheckCircle />

                    <strong>
                        HSN Summary
                    </strong>

                    <span>
                        HSN/SAC working
                    </span>


                    <button
                        type="button"
                        className="gst-dashboard-button"
                        onClick={() =>
                            handleExport(
                                "HSN",
                                "csv"
                            )
                        }
                    >
                        <FiDownload />

                        CSV
                    </button>

                </div>


                <div>

                    <FiCheckCircle />

                    <strong>
                        Reconciliation
                    </strong>

                    <span>
                        Filing audit
                    </span>


                    <button
                        type="button"
                        className="gst-dashboard-button"
                        onClick={() =>
                            handleExport(
                                "RECONCILIATION",
                                "csv"
                            )
                        }
                    >
                        <FiDownload />

                        CSV
                    </button>

                </div>

            </section>

        </div>
    );
};


export default GstFilingPanel;